export default __webpack_public_path__ + "static/3-2cb0266a18e33d1637edd507063c9f35.jpeg";